var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function getCartDrawer() {
    return document.querySelector('cart-drawer');
}
function getCartSections(cartDrawer) {
    var _a, _b;
    return (_b = (_a = cartDrawer === null || cartDrawer === void 0 ? void 0 : cartDrawer.getSectionsToRender) === null || _a === void 0 ? void 0 : _a.call(cartDrawer).map(section => section.id)) !== null && _b !== void 0 ? _b : [
        'cart-drawer',
        'cart-icon-bubble',
    ];
}
function getCartUrl() {
    var _a, _b;
    return (_b = (_a = window.routes) === null || _a === void 0 ? void 0 : _a.cart_url) !== null && _b !== void 0 ? _b : '/cart';
}
function fetchCartSections(sections) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = new URLSearchParams({ sections: sections.join(',') });
        const res = yield fetch(`${getCartUrl()}?${params.toString()}`, {
            headers: { Accept: 'application/json' },
        });
        if (!res.ok)
            throw new Error('Cart sections error');
        return res.json();
    });
}
/**
 * Shopify Ajax Cart API — same origin as the storefront.
 * @see https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
 */
export function addLinesToShopifyCart(items) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const cartDrawer = getCartDrawer();
        const sections = getCartSections(cartDrawer);
        (_a = cartDrawer === null || cartDrawer === void 0 ? void 0 : cartDrawer.setActiveElement) === null || _a === void 0 ? void 0 : _a.call(cartDrawer, document.activeElement);
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
                items,
                sections,
                sections_url: window.location.pathname,
            }),
        });
    });
}
export function openCartDrawerFromAddResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const cartDrawer = getCartDrawer();
        if (!(cartDrawer === null || cartDrawer === void 0 ? void 0 : cartDrawer.renderContents))
            return;
        const sections = getCartSections(cartDrawer);
        const responseJson = yield response.clone().json().catch(() => ({}));
        const cartSections = (_a = responseJson.sections) !== null && _a !== void 0 ? _a : yield fetchCartSections(sections);
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents({ sections: cartSections });
    });
}
